import { Button, Divider, Group, Modal, Space, Text } from "@mantine/core";
import React from "react";

type ConfirmUpdateDatesProps = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  updateBlockedDate: () => void;
  lang: {
    title: string;
    description: string;
    confirm: string;
    cancel: string;
  };
};

export const ConfirmUpdateBlockedDates: React.FC<ConfirmUpdateDatesProps> = ({
  isOpen,
  setOpen,
  updateBlockedDate,
  lang,
}) => (
  <Modal
    opened={isOpen}
    onClose={() => {
      setOpen(false);
    }}
    withCloseButton={false}
    size="lg"
    closeOnClickOutside={false}
    centered
  >
    <div>
      <Text
        size="xl"
        style={{
          fontSize: "18px",
          fontWeight: 700,
          lineHeight: "24.59px",
        }}
      >
        {lang.title}
      </Text>

      <Text size="xs" weight={400} mt={28}>
        {lang.description}
      </Text>

      <Space h="md" />

      <Divider my="sm" />
      <Space h="md" />

      <Group spacing="xl" position="right">
        <Button
          variant="outline"
          style={{
            height: "40px",
            padding: "0 20px",

            width: "150px",
          }}
          onClick={() => setOpen(false)}
        >
          {lang.cancel}
        </Button>

        <Button
          onClick={() => {
            updateBlockedDate();
            setOpen(false);
          }}
          style={{
            height: "40px",
            padding: "0 20px",
            width: "150px",
          }}
        >
          {lang.confirm}
        </Button>
      </Group>
    </div>
  </Modal>
);
